import Add16 from '@carbon/icons-react/es/add/16';
import { Row, Col, Typography } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';

const { Title } = Typography;

const Heading = styled(Title)`
  font-weight: var(--heading-7-weight) !important;
  margin-bottom: 0;
`;

const Container = styled.div`
  padding: 0 var(--layout-01) var(--layout-01);
  border-bottom: 1px solid var(--gray-20);
`;

export const Header = ({
  showResourceModal,
}: {
  showResourceModal: (value: boolean) => void;
}) => (
  <Container>
    <Row justify="space-between" align="middle">
      <Col>
        <Heading level={5}>
          <FormattedMessage id="settings.integrations.hubspot.resource_mappings.title" />
        </Heading>
      </Col>
      <Col>
        <Button
          onClick={() => showResourceModal(true)}
          iconPlacement="right"
          icon={<Add16 />}
          type="primary"
          data-cy="integrations.hubspot.object_add_button"
        >
          <FormattedMessage id="settings.integrations.hubspot.resource_mappings.add" />
        </Button>
      </Col>
    </Row>
  </Container>
);
